import {config} from '../../config/app-config';
import {showErrorNotification, showSuccessNotification} from '../../utils/notifications';
import {apiPost} from '../../utils/api';

export function initVacancyForm() {
    console.log('Initializing vacancy form...');

    const form = document.querySelector('#vacancy-apply-form .contact-form');
    const input = document.querySelector('#vacancy-apply-form #vacancy-phone');
    const label = document.querySelector('#vacancy-apply-form label[for="vacancy-phone"]');
    const submitBtn = document.querySelector('#vacancy-apply-form .submit-btn');

    // Новые элементы для кастомного файл-инпута
    const cvDisplayInput = document.getElementById('cv-display');
    const cvFileInput = document.getElementById('cv');
    const uploadTrigger = document.getElementById('upload-trigger');

    let iti;

    if (!form) {
        console.log('Vacancy form elements not found on this page');
        return;
    }

    // Функция создания элемента ошибки
    function createErrorElement(inputElement) {
        if (!inputElement) return null;
        const errorElement = document.createElement('div');
        errorElement.className = 'field-error-message';
        if (inputElement.parentElement) {
            inputElement.parentElement.classList.add('field-wrapper');
            inputElement.parentElement.appendChild(errorElement);
        }
        return errorElement;
    }

    // Элементы ошибок для полей
    const phoneErrorMessage = createErrorElement(input);
    const nameErrorMessage = createErrorElement(document.getElementById('vacancy-name'));
    const emailErrorMessage = createErrorElement(document.getElementById('vacancy-email'));
    const cvErrorMessage = createErrorElement(cvDisplayInput); // Используем display input для ошибок
    const messageErrorMessage = createErrorElement(document.getElementById('vacancy-message'));
    const checkboxInput = document.querySelector('#vacancy-apply-form .checkbox-input');

    // Универсальные функции для ошибок
    function showFieldError(inputElement, errorElement, message) {
        if (!inputElement || !errorElement) return;
        inputElement.classList.add('field-error');
        errorElement.textContent = message;
        errorElement.classList.add('show');
    }

    function clearFieldError(inputElement, errorElement) {
        if (!inputElement || !errorElement) return;
        inputElement.classList.remove('field-error');
        errorElement.classList.remove('show');
    }

    function showAgreementError() {
        if (checkboxInput) checkboxInput.classList.add('field-error');
    }

    function clearAgreementError() {
        if (checkboxInput) checkboxInput.classList.remove('field-error');
    }

    // Управление лейблом телефона
    function hidePhoneLabel() {
        if (label) {
            label.style.opacity = '0';
            label.style.visibility = 'hidden';
        }
    }

    function showPhoneLabel() {
        if (label && !input.value.trim()) {
            label.style.opacity = '0.6';
            label.style.visibility = 'visible';
        }
    }

    // НОВАЯ ЛОГИКА: Управление кастомным файл-инпутом
    function initCustomFileUpload() {
        if (!cvDisplayInput || !cvFileInput || !uploadTrigger) {
            console.warn('Custom file upload elements not found');
            return;
        }

        // Клик по иконке или текстовому полю открывает файловый диалог
        uploadTrigger.addEventListener('click', function () {
            cvFileInput.click();
        });

        cvDisplayInput.addEventListener('click', function () {
            cvFileInput.click();
        });

        // Обработка выбора файла
        cvFileInput.addEventListener('change', function () {
            const file = this.files[0];
            if (file) {
                // Отображаем имя файла в текстовом поле
                cvDisplayInput.value = file.name;
                const label = document.querySelector('label[for="cv-display"]');
                if (label) {
                    label.style.display = 'none'; // или
                    label.style.visibility = 'hidden'; // или
                    label.style.opacity = '0';
                }

                // Очищаем ошибку если была
                clearFieldError(cvDisplayInput, cvErrorMessage);

                console.log('Файл выбран:', file.name, 'Размер:', file.size, 'Тип:', file.type);
            } else {
                // Если файл не выбран, очищаем поле
                cvDisplayInput.value = 'Надіслати резюме';
            }
        });

        // Обработка drag & drop (бонус)
        cvDisplayInput.addEventListener('dragover', function (e) {
            e.preventDefault();
            this.style.borderColor = '#007bff';
        });

        cvDisplayInput.addEventListener('dragleave', function (e) {
            e.preventDefault();
            this.style.borderColor = '';
        });

        cvDisplayInput.addEventListener('drop', function (e) {
            e.preventDefault();
            this.style.borderColor = '';

            const files = e.dataTransfer.files;
            if (files.length > 0) {
                const file = files[0];

                // Проверяем тип файла
                const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
                if (allowedTypes.includes(file.type)) {
                    // Симулируем выбор файла в скрытом input
                    const dt = new DataTransfer();
                    dt.items.add(file);
                    cvFileInput.files = dt.files;

                    // Отображаем имя файла
                    cvDisplayInput.value = file.name;
                    clearFieldError(cvDisplayInput, cvErrorMessage);
                } else {
                    showFieldError(cvDisplayInput, cvErrorMessage, 'Дозволені формати: PDF, DOC, DOCX');
                }
            }
        });
    }

    // Инициализация intlTelInput
    if (input && label && window.intlTelInput) {
        iti = window.intlTelInput(input, {
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js",
            initialCountry: "ua",
            separateDialCode: true,
            autoPlaceholder: "off",
            preferredCountries: ["ua", "pl", "us", "gb"],
            formatOnDisplay: true,
            nationalMode: false,
            validationNumberTypes: ["MOBILE", "FIXED_LINE"],
            dropdownContainer: document.querySelector('body')
        });
        console.log('intlTelInput initialized for vacancy form');
    } else {
        console.warn('intlTelInput library not found or input elements missing');
    }

    // Валидация телефона
    function validatePhone() {
        const phoneNumber = input.value.trim();
        if (!phoneNumber) {
            showFieldError(input, phoneErrorMessage, 'Поле "Телефон" обов\'язкове для заповнення');
            return false;
        }
        if (iti && iti.isValidNumber()) {
            clearFieldError(input, phoneErrorMessage);
            return true;
        } else {
            showFieldError(input, phoneErrorMessage, 'Невірний номер телефону');
            return false;
        }
    }

    // Валидация имени
    function validateName() {
        const nameField = document.getElementById('vacancy-name');
        if (!nameField) return true;
        const name = nameField.value.trim();
        if (!name) {
            showFieldError(nameField, nameErrorMessage, 'Поле "Ім\'я" обов\'язкове для заповнення');
            return false;
        } else {
            clearFieldError(nameField, nameErrorMessage);
            return true;
        }
    }

    // Валидация email
    function validateEmail() {
        const emailField = document.getElementById('vacancy-email');
        if (!emailField) return true;
        const email = emailField.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            showFieldError(emailField, emailErrorMessage, 'Поле "E-Mail" обов\'язкове для заповнення');
            return false;
        } else if (!emailRegex.test(email)) {
            showFieldError(emailField, emailErrorMessage, 'Невірний формат E-Mail');
            return false;
        } else {
            clearFieldError(emailField, emailErrorMessage);
            return true;
        }
    }

    // ОБНОВЛЕННАЯ валидация файла резюме
    function validateCV() {
        const file = cvFileInput.files[0];
        if (!file) {
            showFieldError(cvDisplayInput, cvErrorMessage, 'Будь ласка, додайте резюме');
            return false;
        }
        const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (!allowedTypes.includes(file.type)) {
            showFieldError(cvDisplayInput, cvErrorMessage, 'Дозволені формати: PDF, DOC, DOCX');
            return false;
        }
        if (file.size > maxSize) {
            showFieldError(cvDisplayInput, cvErrorMessage, 'Розмір файлу не повинен перевищувати 5 МБ');
            return false;
        }
        clearFieldError(cvDisplayInput, cvErrorMessage);
        return true;
    }

    // Валидация комментария
    function validateMessage() {
        const messageField = document.getElementById('vacancy-message');
        if (!messageField) return true;
        const message = messageField.value.trim();
        if (!message) {
            showFieldError(messageField, messageErrorMessage, 'Поле "Коментар" обов\'язкове для заповнення');
            return false;
        } else {
            clearFieldError(messageField, messageErrorMessage);
            return true;
        }
    }

    // Валидация чекбокса
    function validateAgreement() {
        if (!checkboxInput) return true;
        if (!checkboxInput.checked) {
            showAgreementError();
            return false;
        } else {
            clearAgreementError();
            return true;
        }
    }

    // Обработчики событий
    function setupEventListeners() {
        if (input && label) {
            input.addEventListener('focus', hidePhoneLabel);
            input.addEventListener('blur', function () {
                if (!this.value.trim()) showPhoneLabel();
                validatePhone();
            });
            input.addEventListener('input', function () {
                if (this.value.trim()) hidePhoneLabel();
                else showPhoneLabel();
                clearFieldError(input, phoneErrorMessage);
            });
            input.addEventListener('change', function () {
                if (this.value.trim()) hidePhoneLabel();
                else showPhoneLabel();
                clearFieldError(input, phoneErrorMessage);
            });
            input.addEventListener('keyup', function () {
                if (this.value.trim()) hidePhoneLabel();
                else showPhoneLabel();
                clearFieldError(input, phoneErrorMessage);
            });
            input.addEventListener('countrychange', function () {
                clearFieldError(input, phoneErrorMessage);
            });
            if (input.value.trim()) hidePhoneLabel();
            else showPhoneLabel();
            label.addEventListener('click', function () {
                input.focus();
            });
        }

        const nameField = document.getElementById('vacancy-name');
        if (nameField) {
            nameField.addEventListener('blur', validateName);
            nameField.addEventListener('input', function () {
                clearFieldError(this, nameErrorMessage);
            });
        }

        const emailField = document.getElementById('vacancy-email');
        if (emailField) {
            emailField.addEventListener('blur', validateEmail);
            emailField.addEventListener('input', function () {
                clearFieldError(this, emailErrorMessage);
            });
        }

        // УБИРАЕМ старые обработчики для cvField, так как теперь используем кастомную логику

        const messageField = document.getElementById('vacancy-message');
        if (messageField) {
            messageField.addEventListener('blur', validateMessage);
            messageField.addEventListener('input', function () {
                clearFieldError(this, messageErrorMessage);
            });
        }

        if (checkboxInput) {
            checkboxInput.addEventListener('change', function () {
                if (this.checked) clearAgreementError();
            });
        }
    }

    // Отправка формы
    async function submitFormToServer(formData) {
        try {
            console.log('Отправка данных вакансии на сервер...', formData);
            if (submitBtn) {
                const originalText = submitBtn.textContent;
                submitBtn.textContent = 'Відправка...';
                submitBtn.disabled = true;
            }

            const response = await apiPost(config.api.paths.vacancyForm, formData, {
                auth: false,
                contentType: false,
                processData: false
            });

            console.log('Ответ сервера:', response);
            showSuccessNotification('Ваше резюме успішно відправлено! Ми зв\'яжемося з вами найближчим часом.');
            form.reset();

            // Очищаем кастомные поля
            if (cvDisplayInput) cvDisplayInput.value = '';
            if (iti) iti.setNumber('');

            showPhoneLabel();
            if (submitBtn) {
                submitBtn.textContent = 'Відправити резюме';
                submitBtn.disabled = false;
            }
            return response;
        } catch (error) {
            console.error('Ошибка при отправке формы:', error);
            let errorMessage = 'Помилка при відправці резюме. Спробуйте ще раз.';
            if (error.response && error.response.data && error.response.data.detail) {
                errorMessage = error.response.data.detail;
            }
            showErrorNotification(errorMessage);
            if (submitBtn) {
                submitBtn.textContent = 'Відправити резюме';
                submitBtn.disabled = false;
            }
            throw error;
        }
    }

    // Обработка сабмита
    form.addEventListener('submit', async function (e) {
        e.preventDefault();
        console.log('=== ОТПРАВКА ФОРМЫ ВАКАНСИИ ===');

        const isNameValid = validateName();
        const isPhoneValid = validatePhone();
        const isEmailValid = validateEmail();
        const isCVValid = validateCV();
        const isMessageValid = validateMessage();
        const isAgreementValid = validateAgreement();

        const isFormValid = isNameValid && isPhoneValid && isEmailValid && isCVValid && isMessageValid && isAgreementValid;

        console.log('Валидация:', isFormValid ? 'ПРОЙДЕНА' : 'НЕ ПРОЙДЕНА');
        if (!isFormValid) {
            showErrorNotification('Будь ласка, виправте помилки у формі');
            return;
        }

        const formData = new FormData();
        formData.append('name', document.getElementById('vacancy-name')?.value.trim() || '');
        formData.append('phone', iti.getNumber());
        formData.append('phone_country', iti.getSelectedCountryData().iso2);
        formData.append('email', document.getElementById('vacancy-email')?.value.trim() || '');

        // ИСПОЛЬЗУЕМ скрытый файловый input
        if (cvFileInput.files[0]) {
            formData.append('cv', cvFileInput.files[0]);
        }

        formData.append('message', document.getElementById('vacancy-message')?.value.trim() || '');
        formData.append('agreement', checkboxInput?.checked || false);
        const vacancyTitle = document.querySelector('.vacancy-head')?.textContent.trim() || '';
        formData.append('vacancy_title', vacancyTitle);

        try {
            await submitFormToServer(formData);
        } catch (error) {
            // Ошибка уже обработана
        }
    });

    // ИНИЦИАЛИЗИРУЕМ кастомный файл-инпут
    initCustomFileUpload();
    setupEventListeners();
    console.log('Vacancy form initialized successfully');
    if (iti) window.itiVacancy = iti; // Для отладки
}

export function hasVacancyForm() {
    return document.querySelector('#vacancy-apply-form .contact-form') !== null;
}